import { booleanAttribute, Component, computed, input, signal } from '@angular/core';
import { NgIcon, provideIcons } from '@ng-icons/core';
import { lucideCircleAlert, lucideCircleCheck, lucideInfo, lucideX } from '@ng-icons/lucide';
import { HlmButton } from '@spartan-ng/helm/button';
import { cva, VariantProps } from 'class-variance-authority';

export const alertVariants = cva('p-xs flex rounded-full', {
  variants: {
    variant: {
      informative: 'text-feedback-informative-main bg-feedback-informative-lightest',
      positive: 'text-feedback-positive-main bg-feedback-positive-lightest',
      negative: 'text-feedback-negative-darker bg-feedback-negative-lightest',
      warning: 'text-feedback-warning-main bg-feedback-warning-lightest',
    },
  },
  defaultVariants: {
    variant: 'informative',
  },
});

const iconVariants = {
  informative: 'lucideInfo',
  positive: 'lucideCircleCheck',
  negative: 'lucideCircleAlert',
  warning: 'lucideCircleAlert',
};

export type AlertVariants = VariantProps<typeof alertVariants>;

@Component({
  selector: 'app-alerte',
  imports: [NgIcon, HlmButton],
  providers: [provideIcons({ lucideX, lucideInfo, lucideCircleCheck, lucideCircleAlert })],
  templateUrl: './alerte.component.html',
})
export class AlerteComponent {
  title = input<string | null>();
  message = input<string>();
  type = input<AlertVariants['variant']>('informative');
  disposable = input<boolean, boolean | string>(false, { transform: booleanAttribute });

  masquerAlerte = signal(false);

  protected readonly _computedClass = computed(() => alertVariants({ variant: this.type() }));
  protected readonly _computedIcon = computed(() => iconVariants[this.type() ?? 'informative']);
}
